import { logout } from '@ogsnetwork/opp-redux-lib';
import { useCallback, useEffect } from 'react';
import { useAppDispatch, useAppSelector, usePrevious } from '../index';
export function useLogout(props) {
    const authentication = useAppSelector((state) => state.authentication);
    const dispatch = useAppDispatch();
    const previousStatus = usePrevious(authentication.status);
    const dispatchLogout = useCallback(() => {
        dispatch(logout());
    }, []);
    useEffect(() => {
        var _a, _b;
        if (authentication.status === 'error' && previousStatus === 'registering') {
            (_a = props === null || props === void 0 ? void 0 : props.onError) === null || _a === void 0 ? void 0 : _a.call(props);
        }
        if (authentication.status === 'loggedOut' && previousStatus === 'submitting') {
            (_b = props === null || props === void 0 ? void 0 : props.onLogout) === null || _b === void 0 ? void 0 : _b.call(props);
        }
    }, [authentication.status]);
    return {
        dispatchLogout,
        error: authentication.error,
        status: authentication.status
    };
}
